/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'notes': {
    width: 14,
    height: 20,
    viewBox: '0 0 14 20',
    data: '<path pid="0" d="M6.87 0c.952 0 1.772.65 1.999 1.56h1.11c.46 0 .835.373.835.834L10.813 3h1.762c.644 0 1.167.522 1.167 1.167v13.966c0 .644-.523 1.166-1.167 1.166H1.167A1.166 1.166 0 0 1 0 18.133V4.167C0 3.522.522 3 1.167 3h1.76v-.606c0-.461.375-.835.836-.835h1.11A2.06 2.06 0 0 1 6.87 0zM12 15H2v1h10v-1zm0-4H2v1h10v-1zm0-4H2v1h10V7zM6.87 1a1.06 1.06 0 0 0-1.03.81.97.97 0 0 1-.94.75h-.972v1.054h5.886V2.559h-.972a.97.97 0 0 1-.941-.748A1.06 1.06 0 0 0 6.87 1z" _fill="#BCBCBC" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/notes.js